import { useSelector } from 'react-redux';
import { readStates, saveStates, states } from '@/constants/lifecycle';
import findResult from '@/utils/resultsHelper';
import { datasetManagePermissions } from '../../sharing/constants';
import canManageDataset from '../../sharing/helper';
import { datasourceSupportsCohort } from '../../datasource/helper';
import { datasourceFields } from '../../datasource/state/state';
import { settingsPanels } from '../state/state';

const withoutItem = (catalogue, metrics) => ({
  ...readStates,
  name: catalogue.catalogue?.title,
  canChangeSettings: false,
  canRead: false,
  ...settingsPanels(),
  metricsReadStatus: metrics?.readStatus || states.NONE,
});

const withItem = (item, catalogue, role, settings, datasourceFeatures, metrics) => ({
  canChangeSettings: item.saveStatus !== states.PENDING && item[datasetManagePermissions.SETTINGS],
  canRead: item.readStatus === states.SUCCESS && !canManageDataset(item) ? false : role.permissions.datasets.read,
  exists: true,
  name: catalogue.catalogue?.title,
  panels: settings?.panels || settingsPanels().panels,
  readErrors: item.readErrors,
  readStatus: item.readStatus,
  saveErrors: settings.saveErrors,
  datasourceSupportsCohort: datasourceSupportsCohort(datasourceFeatures),
  metricsReadStatus: metrics?.readStatus || states.NONE,
});

const useDatasetSettings = ({ category, code }) => useSelector(({
  auth: { role },
  catalogues: { catalogues },
  datasetDatasource: { features },
  datasetMetrics: { datasetMetrics },
  datasetSettings: { settings },
  datasetUsers: { permissions },
}) => {
  const item = findResult(permissions, category, code);
  const config = findResult(settings, category, code) || { ...saveStates };
  const catalogue = findResult(catalogues, category, code) || { catalogue: { title: '' } };
  const datasourceFeatures = findResult(features, category, code) || { ...datasourceFields() };
  const metrics = findResult(datasetMetrics, category, code);

  return item ? withItem(item, catalogue, role, config, datasourceFeatures, metrics) : withoutItem(catalogue, metrics);
});

export default {
  useDatasetSettings,
};
